var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningNotification(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.063,
    height: 17.008,
    viewBox: "0 0 19.063 17.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25599",
    "data-name": "Group 25599",
    transform: "translate(12605 -3494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25598",
    "data-name": "Group 25598",
    transform: "translate(-12605.998 3493.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13652",
    "data-name": "Path 13652",
    d: "M3,17.01a2,2,0,0,1-1.73-3L8.8,1a2,2,0,0,1,3.46,0l7.53,13.01a2,2,0,0,1-1.73,3Zm15.06-2L10.529,2,3,15.01Z",
    fill: "#bd4f00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13653",
    "data-name": "Path 13653",
    d: "M9.529,7.01V10a1,1,0,0,0,2,0V7.01a1,1,0,0,0-2,0Z",
    fill: "#bd4f00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(9.529 12.01)",
    fill: "#bd4f00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningNotification);
export default __webpack_public_path__ + "static/media/warning-notification.50838e6cc162bb9f78e46c8427a06e2b.svg";
export { ForwardRef as ReactComponent };